import { pxToRem } from '@anwb/poncho/design-tokens/style-utilities';
import styled, { DefaultThemeProps, css } from 'styled-components';

const NavigationButtonStyles = ({ theme }: DefaultThemeProps) => css`
	display: flex;
	justify-content: space-between;

	@media (max-width: ${pxToRem(theme.viewportBreakpoint.sm)}) {
		flex-direction: column-reverse;
		gap: ${pxToRem(theme.spacing['200'])};
	}
`;

export const NavigationButtonContainer = styled.div`
	${NavigationButtonStyles}
`;
